module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"note-label":"Note de suivi","show-more":"Voir plus","show-less":"Voir moins"},"en":{"note-label":"Notes","show-more":"Show more","show-less":"Show less"}}')
  delete Component.options._Ctor
}
